export const testimonyData = [
  {
    id: 1,
    name: "John Anderson",
    role: "Senior Software Engineer",
    company: "TechCorp Solutions",
    quote: {
      en: "Outstanding developer with excellent problem-solving skills. Delivered high-quality work consistently and met all project deadlines with professionalism.",
      id: "Developer yang luar biasa dengan kemampuan problem-solving yang sangat baik. Konsisten memberikan hasil berkualitas tinggi dan selalu tepat tenggat dengan profesional.",
    },
    linkedin: "https://www.linkedin.com/in/johndoe/",
    path_url: "https://example.com/testimonial1",
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    role: "Product Manager",
    company: "InnovateTech Inc",
    quote: {
      en: "A reliable team player with great attention to detail. Always brings creative solutions to the table and stays current with the latest technology trends.",
      id: "Rekan tim yang andal dan sangat teliti. Selalu membawa solusi kreatif dan mengikuti tren teknologi terbaru.",
    },
    linkedin: "https://www.linkedin.com/in/sarahmitchell/",
    path_url: "https://example.com/testimonial2",
  },
  {
    id: 3,
    name: "Michael Chen",
    role: "Lead Developer",
    company: "Digital Ventures",
    quote: {
      en: "Exceptional work ethic and technical expertise. A pleasure to collaborate with on complex projects.",
      id: "Etos kerja dan keahlian teknis yang luar biasa. Senang sekali bisa berkolaborasi di proyek-proyek yang kompleks.",
    },
    linkedin: "https://www.linkedin.com/in/michaelchen/",
    path_url: "https://example.com/testimonial3",
  },
  {
    id: 4,
    name: "Emily Rodriguez",
    role: "UX/UI Designer",
    company: "Creative Studio Pro",
    quote: {
      en: "Working together was seamless. Great communication skills and deep understanding of both design and development perspectives. Highly recommended for any web development project.",
      id: "Kerja sama berjalan sangat lancar. Komunikasinya bagus dan paham betul sisi desain maupun development. Sangat direkomendasikan untuk proyek web apa pun.",
    },
    linkedin: "https://www.linkedin.com/in/emilyrodriguez/",
    path_url: "https://example.com/testimonial4",
  },
  {
    id: 5,
    name: "David Thompson",
    role: "Engineering Manager",
    company: "CloudTech Systems",
    quote: {
      en: "Demonstrates strong technical skills and adaptability. Quick learner who takes initiative and delivers results under tight deadlines.",
      id: "Kemampuan teknis dan adaptasinya kuat. Cepat belajar, punya inisiatif, dan tetap memberikan hasil meski tenggat waktunya ketat.",
    },
    linkedin: "https://www.linkedin.com/in/davidthompson/",
    path_url: "https://example.com/testimonial5",
  },
  {
    id: 6,
    name: "Jessica Williams",
    role: "Quality Assurance Lead",
    company: "SoftwarePro Labs",
    quote: {
      en: "Consistently produces clean, well-documented code. Excellent debugging skills and commitment to quality. A valuable asset to any development team.",
      id: "Selalu menghasilkan kode yang bersih dan terdokumentasi dengan baik. Jago debugging dan berkomitmen pada kualitas. Aset berharga bagi tim development mana pun.",
    },
    linkedin: "https://www.linkedin.com/in/jessicawilliams/",
    path_url: "https://example.com/testimonial6",
  },
  {
    id: 7,
    name: "Robert Martinez",
    role: "Tech Lead",
    company: "WebSolutions Group",
    quote: {
      en: "Dependable developer with strong frontend expertise and excellent collaboration skills.",
      id: "Developer yang bisa diandalkan dengan keahlian frontend yang kuat dan kemampuan kolaborasi yang sangat baik.",
    },
    linkedin: "https://www.linkedin.com/in/robertmartinez/",
    path_url: "https://example.com/testimonial7",
  },
  {
    id: 8,
    name: "Amanda Foster",
    role: "Scrum Master",
    company: "Agile Innovations",
    quote: {
      en: "Professional approach to every challenge. Great team member who contributes positively to project success and team dynamics.",
      id: "Profesional dalam menghadapi setiap tantangan. Anggota tim hebat yang berkontribusi positif pada keberhasilan proyek dan dinamika tim.",
    },
    linkedin: "https://www.linkedin.com/in/amandafoster/",
    path_url: "https://example.com/testimonial8",
  },
];
